export class ShowLoader {
  static readonly type = '[Loader] Show loader';

  constructor(public showTimeout= 0) {
  }

}

export class HideLoader {
  static readonly type = '[Loader] Hide loader';
}
